var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-dashboard" },
    [
      _c(
        "div",
        { staticClass: "tms-dashboard__panel-header row" },
        [
          _c(
            "div",
            { staticClass: "tms-dashboard__panel-container-without-button" },
            [
              _c("HKLLeftRight", [
                _c("div", { staticClass: "tms-dashboard__panel-title-box" }, [
                  _c("div", { staticClass: "tms-dashboard__panel-title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "tenancy.greenOperation.sustainabilityPartnershipProgramme"
                          )
                        ) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass: "fa fa-refresh dark flat icon_refresh",
                      on: { click: _vm.refresh },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tms-dashboard__panel-view-all" },
                  [
                    _c(
                      "HKLRouterLink",
                      {
                        staticClass: "none",
                        attrs: { to: _vm.viewAllLinkParam },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("viewAll")) +
                            " >\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("HKLButton", {
            attrs: { color: "darkblue", action: "reset" },
            on: { click: _vm.reset },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("HKLTable", {
        ref: "tableRef",
        staticClass: "non-margin",
        attrs: { columns: _vm.cols, dataSource: _vm.sortedData },
        on: { sort: _vm.watchSorting },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }